import { render } from "./TransitionPage.vue?vue&type=template&id=373c08c6"
import script from "./TransitionPage.vue?vue&type=script&lang=js"
export * from "./TransitionPage.vue?vue&type=script&lang=js"

import "./TransitionPage.vue?vue&type=style&index=0&id=373c08c6&lang=css"
script.render = render

export default script